// 配置Vue使用第三方库或自定义库
import Vue from 'vue';
import VueQuillEditor from 'vue-quill-editor';
import draggable from 'vuedraggable';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'; // lang i18n
import moment from 'moment';
import momentTime from 'moment-timezone';
import VueCompositionAPI from '@vue/composition-api';
import CustomColorPicker from '@/components/custom-color-picker';
import currencyDisplay from '@/components/currency-display/currency-display';
import VueLibs from './utils/vue-libs';
import Components from './components/Globals/components'; // import global components
import i18n from './lang';
import ElTableDraggable from 'element-ui-el-table-draggable';
import FileSelectUpload from '@/components/file-select-upload';

const initDateProxy = () => {
  window.Date = new Proxy(Date, {
    construct: function (target, args) {
      const argsLength = args ? args.length : 0;
      if (argsLength == 1 && typeof args[0] === 'string') {
        const momentDate = moment(args[0]);
        const timeStamp = +momentDate;
        const date = new target(timeStamp);
        return date;
      }
      const date = new target(...args);
      return date;
    },
  });
};

const intVueExtend = () => {
  Vue.use(VueLibs);
  Vue.use(VueQuillEditor);
  Vue.use(CustomColorPicker);

  Vue.component('draggable', draggable);
  Vue.component('currency-display', currencyDisplay);
  Vue.component('el-table-draggable', ElTableDraggable);
  Vue.component('file-select-upload', FileSelectUpload);

  // 使用饿了么UI组件;
  ElementUI.Dialog.props.closeOnClickModal.default = false;
  ElementUI.Dialog.props.top.default = '8vh';

  Vue.use(ElementUI, {
    locale,
    size: 'small',
    i18n: (key, value) => i18n.t(key, value),
  });

  // 使用全局组件
  Vue.use(Components);

  // 使用vue3.0的CompositionAPI
  Vue.use(VueCompositionAPI);

  // 挂载moment
  Vue.prototype.$moment = moment;

  // 指定时区为东八区
  // momentTime.tz.setDefault('Asia/Shanghai');

  // 设置全局Date对象代理
  initDateProxy();
};

export { intVueExtend };
